import { actionSimple } from '../../modules/app/actionService';
import {
	SEED_FETCH,
	SEED_REFRESH_CLIENT,
	SEED_REFRESH_SERVER,
	SEED_SET_CLIENT,
	SEED_SET_NONCE,
	SEED_SET_SERVER_HASHED,
} from './seed.constants';

export const seedSetServerHashed = actionSimple(SEED_SET_SERVER_HASHED);
export const seedSetClient = actionSimple(SEED_SET_CLIENT);
export const seedSetNonce = actionSimple(SEED_SET_NONCE);
export const seedFetch = actionSimple(SEED_FETCH);
export const seedRefreshClient = actionSimple(SEED_REFRESH_CLIENT);
export const seedRefreshServer = actionSimple(SEED_REFRESH_SERVER);
